import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
import { computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useFullWidth } from '@/composables/useFullWidth';
import { useWorkspace } from '@/composables/workspaces';
import Content from '@/components/workspaces_delete_layout/Content.vue';
import Scaffold from '@/components/Scaffold.vue';
import WorkspaceSubheader from '@/components/workspaces/WorkspaceSubheader.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Delete',
    setup(__props) {
        useFullWidth();
        const router = useRouter();
        const store = useStore();
        const { workspace } = useWorkspace();
        const sessionId = computed(() => store.getters.session.id);
        const members = computed(() => workspace.value?.members || []);
        const isOwner = computed(() => {
            return !!members.value.find((member) => member.owner && member.id === sessionId.value);
        });
        watch(workspace, (value) => {
            if (!isOwner.value) {
                router.push({ name: 'showWorkspace', params: { workspaceId: value.id } });
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (_unref(workspace) && _unref(isOwner))
                    ? (_openBlock(), _createBlock(Scaffold, {
                        key: 0,
                        class: "h-screen pt-10"
                    }, {
                        subheader: _withCtx(() => [
                            _createVNode(WorkspaceSubheader)
                        ]),
                        content: _withCtx(() => [
                            _createElementVNode("div", null, [
                                _createVNode(Content, { workspace: _unref(workspace) }, null, 8, ["workspace"])
                            ])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
